<template>
  <AppClientSimpleLayout>
    <div class="p-2 sm:p-4 mx-auto w-full max-w-5xl">
      <h2 class="text-xl font-iroha text-center text-CLIENT_PRIMARY_PINK">
        {{ information.subject }}
      </h2>
      <p class="mb-4 text-sm md:text-base font-iroha text-center text-gray-500">
        {{ formatCreatedAt(information) }}
      </p>

      <div class="shadow overflow-hidden sm:rounded-md">
        <div class="px-4 py-5 bg-white sm:p-6">
          <p class="text-md my-6 whitespace-pre-wrap">
            {{ information.description }}
          </p>
        </div>
      </div>
      <div class="px-4 py-3 flex justify-between sm:px-6">
        <div>
          <button
            class="py-2 px-4 rounded-md font-iroha text-CLIENT_PRIMARY_PINK"
            @click="onClickedBack">
            ＜戻る
          </button>
        </div>
      </div>
    </div>
  </AppClientSimpleLayout>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import {
  computed,
} from 'vue'
import AppClientSimpleLayout from '@/Layouts/AppClientSimpleLayout'

const props = defineProps({
  information: {
    type: Object,
    default: () => ({ id: null }),
  },
})

const formatCreatedAt = (information) => {
  const date = moment(information.created_at)
  const formatDate = date.format('yyyy.MM.DD')
  return formatDate
}

const onClickedBack = () => {
  Inertia.get(route('portal.information.index'))
}

</script>
